/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum UploadAttachmentErrorCode {
    Unknown = 0,
    FileNullOrEmpty = 1,
    DescriptionNullOrEmpty = 2,
    FileTooLarge = 3,
    FileExtensionBanned = 4,
    DuplicateFileName = 5,
}
